import { Component } from '@angular/core';

@Component({
    selector: 'pdf-findbar-message-container',
    templateUrl: './pdf-findbar-message-container.component.html',
    styleUrls: ['./pdf-findbar-message-container.component.css'],
    standalone: false
})
export class PdfFindbarMessageContainerComponent {}
